export default __webpack_public_path__ + "static/media/web-logo-2.388ed3cc.png";